import { render, staticRenderFns } from "./WizardHeader.vue?vue&type=template&id=7c5d14f2"
import script from "./WizardHeader.vue?vue&type=script&lang=ts"
export * from "./WizardHeader.vue?vue&type=script&lang=ts"
import style0 from "./WizardHeader.vue?vue&type=style&index=0&id=7c5d14f2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports